import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ListContext = /*#__PURE__*/createContext(undefined);
export const ListContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ListContext.Provider, {
    value: props,
    children: children
  });
};
export const useListContext = () => {
  const state = useContext(ListContext);
  if (!state) {
    throw new Error('useListContext must be used within ListContextProvider');
  }
  return state;
};